/**
 * Soglie prezzo max Studio (crediti).
 * ≤30 step 5 · ≤100 step 10 · ≤200 step 25 · poi 200+.
 */

/** @typedef {{ key: string, label: string, min: number, max: number, openEnded?: boolean }} PriceBand */

/** @type {PriceBand[]} */
export const PRICE_BANDS = [
  { key: '5', label: '1-5', min: 1, max: 5 },
  { key: '10', label: '6-10', min: 6, max: 10 },
  { key: '15', label: '11-15', min: 11, max: 15 },
  { key: '20', label: '16-20', min: 16, max: 20 },
  { key: '25', label: '21-25', min: 21, max: 25 },
  { key: '30', label: '26-30', min: 26, max: 30 },
  { key: '40', label: '31-40', min: 31, max: 40 },
  { key: '50', label: '41-50', min: 41, max: 50 },
  { key: '60', label: '51-60', min: 51, max: 60 },
  { key: '70', label: '61-70', min: 61, max: 70 },
  { key: '80', label: '71-80', min: 71, max: 80 },
  { key: '90', label: '81-90', min: 81, max: 90 },
  { key: '100', label: '91-100', min: 91, max: 100 },
  { key: '125', label: '101-125', min: 101, max: 125 },
  { key: '150', label: '126-150', min: 126, max: 150 },
  { key: '175', label: '151-175', min: 151, max: 175 },
  { key: '200', label: '176-200', min: 176, max: 200 },
  { key: '200+', label: '200+', min: 201, max: 999, openEnded: true },
];

export const PRICE_BAND_GROUPS = [
  { id: 'low', label: '≤30', bands: PRICE_BANDS.slice(0, 6) },
  { id: 'mid', label: '≤100', bands: PRICE_BANDS.slice(6, 13) },
  { id: 'high', label: '≤200', bands: PRICE_BANDS.slice(13, 17) },
  { id: 'top', label: 'oltre', bands: PRICE_BANDS.slice(17) },
];

/** Valore persistito (max della soglia; 999 = 200+). */
export function priceBandStoredValue(band) {
  if (!band) return 0;
  return Number(band.max) || 0;
}

/** Trova soglia da prezzo salvato o legacy. */
export function findPriceBand(maxPrice) {
  const n = Number(maxPrice);
  if (!Number.isFinite(n) || n <= 0) return null;
  if (n >= 201) return PRICE_BANDS[PRICE_BANDS.length - 1];
  return PRICE_BANDS.find((b) => !b.openEnded && n <= b.max) || PRICE_BANDS[PRICE_BANDS.length - 1];
}

/** Etichetta corta per chip/toggle (€ se assente). */
export function formatPriceBandLabel(maxPrice, { empty = '€' } = {}) {
  const band = findPriceBand(maxPrice);
  return band ? band.label : empty;
}

/** HTML chip gruppi per il popover prezzo. */
export function renderPriceBandPickerHtml(selectedMax = 0) {
  const selected = findPriceBand(selectedMax);
  const selectedKey = selected?.key || '';
  return PRICE_BAND_GROUPS.map(
    (group) => `
    <div class="studio-price-band-group" data-group="${group.id}">
      <span class="studio-price-band-group__lbl">${group.label}</span>
      <div class="studio-price-chips" role="group" aria-label="Soglie ${group.label}">
        ${group.bands
          .map((b) => {
            const on = b.key === selectedKey;
            return `<button type="button" class="studio-price-chip${on ? ' is-on' : ''}" data-price-max="${b.max}" data-price-key="${b.key}" aria-pressed="${on ? 'true' : 'false'}">${b.label}</button>`;
          })
          .join('')}
      </div>
    </div>`,
  ).join('');
}
